module.exports = __webpack_public_path__ + "img/bucket.bd93db49.svg";